export default __webpack_public_path__ + "static/media/iconPage.16257a78.png";